import React, { createContext } from 'react'
import localforage from 'localforage'

const cacheManager = {
  writeData: (key: string, data: any) => localforage.setItem(key, data),
  readData: (key: string) => localforage.getItem(key),
  removeData: (key: string) => localforage.removeItem(key),
  clear: () => localforage.clear(),
}

if (localStorage.swupdate) localStorage.removeItem('swupdate')

export const CacheContext = createContext({
  writeData: async (key: any, data: any): Promise<void> => {},
  readData: async (key: any): Promise<unknown> => {
    return null
  },
  removeData: async (key: any): Promise<void> => {},
  clear: async (): Promise<void> => {},
})

const CacheProvider = ({ children }: { children: React.ReactNode }) => (
  <CacheContext.Provider value={cacheManager}>{children}</CacheContext.Provider>
)

export default CacheProvider
